'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TableHeadingCellContainer = require('../../../components/TableHeadingCellContainer');

var _TableHeadingCellContainer2 = _interopRequireDefault(_TableHeadingCellContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Obsolete
var EnhancedHeadingCell = _TableHeadingCellContainer2.default;

exports.default = EnhancedHeadingCell;


//////////////////
// WEBPACK FOOTER
// ./~/griddle-react/dist/module/plugins/local/components/TableHeadingCellContainer.js
// module id = 1301
// module chunks = 1